/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_DescriptionInputs */

const zh_usage_description = /** @type {(inputs: Usage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看每个会话的积分消耗情况。`)
};

const en_usage_description = /** @type {(inputs: Usage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View credit consumption per conversation.`)
};

const es_usage_description = /** @type {(inputs: Usage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver el consumo de créditos por conversación.`)
};

/**
* | output |
* | --- |
* | "View credit consumption per conversation." |
*
* @param {Usage_DescriptionInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const usage_description = /** @type {((inputs?: Usage_DescriptionInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_DescriptionInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usage_description(inputs)
	if (locale === "en") return en_usage_description(inputs)
	return es_usage_description(inputs)
});